/** Namespace `audience` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const audience = {
  title: "Người dùng",
  subtitle: "Chọn một app để xem số của riêng app đó. Ngày tính theo giờ Việt Nam.",
  loadFailed: "Không đọc được số liệu người dùng.",
  aggregateNote:
    "ba thẻ dưới là phép CỘNG các app (một người ở hai app bị đếm hai lần). Số của từng app ở mục « Theo từng app ».",
  newUsersInPeriod: "Người dùng mới ({period})",
  activeNotSummable: "Không cộng được « Người dùng hoạt động » qua các nguồn.",
  dailyTrend: "Diễn biến theo ngày",
  dailyOnlyNote:
    "Chỉ có độ mịn theo ngày. Gộp thành tuần/tháng cho một phép đếm-phân-biệt không phải là phép cộng — một người vào app cả bảy ngày sẽ bị đếm bảy lần.",
  noSourcesTitle: "Chưa có nguồn nào được khai.",
  noSourcesBefore: "Worker khai nguồn xuống cơ sở dữ liệu lúc khởi động — xem",
  "col.source": "Nguồn",
  "col.total": "Tổng",
  "col.new": "Mới",
  "col.active": "Hoạt động",
  "col.activeBasis": "Cơ sở đo « hoạt động »",
  "col.updated": "Cập nhật",
  activeRefusal: "Các nguồn đo bằng những cơ sở khác nhau ({bases}) — cộng lại sẽ là cộng hai khái niệm khác nhau.",
} as const;
